import { useNewRevision, type ProjectRow } from '../../hooks/useProjects.js';
import { RevisionsLedger } from './RevisionsLedger.js';

// ── Types ────────────────────────────────────────────────────────────────────

interface DeliveredViewProps {
  project: ProjectRow;
}

// ── DeliveredView ────────────────────────────────────────────────────────────
// Shown when project status = 'delivered'.
// The "New revision" button lives in the RevisionsLedger header.

export function DeliveredView({ project }: DeliveredViewProps) {
  const newRevision = useNewRevision(project.id);

  return (
    <RevisionsLedger
      projectId={project.id}
      onNewRevision={() => newRevision.mutate()}
      isNewRevisionPending={newRevision.isPending}
      newRevisionError={
        newRevision.isError
          ? (newRevision.error instanceof Error
              ? newRevision.error.message
              : String(newRevision.error))
          : null
      }
    />
  );
}
